import React, { useEffect, useState } from "react";
import { jarallax, jarallaxElement } from "jarallax";
import 'jarallax/dist/jarallax.css';
import 'jarallax/dist/jarallax.min.js';
import 'jarallax/dist/jarallax-element.min.js';
import "jquery-ui-dist/jquery-ui";
import axiosInstance from '../axiosConfig';
import '../styles/loader.css';
import Loader from "../components/Loader";

const VisionMission = () => {

    const [loading, setLoading] = useState(true);
    const [aboutpages, setAboutpage] = useState([]);
    const [error, setError] = useState(null);
    // const [heading, setHeading] = useState("Our Team");

    useEffect(() => {
        jarallax(document.querySelectorAll('.jarallax'));
    }, [aboutpages]);
    useEffect(() => {
        const fetchTrendingStyle = async () => {
            try {
                const response = await axiosInstance.get('/cms-page/about');
                if (response.data.success) {
                    console.log(response.data.cmspage);
                    setAboutpage(response.data.cmspage || []);
                }else{
                    setError('Failed to load cmspage');
                }
            } catch (error) {
                console.error("Error fetching trending styles:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchTrendingStyle();
    }, []);

    const VisionMisionData = aboutpages.map((aboutpage, index) => ({
        count: `-${50 + index}`,
        heading: aboutpage.section_title,
        description: aboutpage.description,
    }));

   
    if (loading) {
        return <Loader />;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <section className="vision-mission jarallax no-top">
            <div className="de-gradient-edge-top"></div>
            <img src="assets/images/background/1.jpg" className="jarallax-img" alt="" />
            <div className="container relative z1000">
                <div className="row gx-5">
                    {VisionMisionData.map((item, index) => (
                        <div className="col-lg-6 jarallax" key={index} data-jarallax-element={item.count}>
                            <div className="d-sch-table">
                                <h2 className="wow fadeIn text-center">{item.heading}</h2>
                                <div className="de-separator"></div>
                                <div
                                    className="vision-mission-description"
                                    dangerouslySetInnerHTML={{ __html: item.description }}
                                />
                                <div className="d-deco"></div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="de-gradient-edge-bottom"></div>
        </section>
    );
}

export default VisionMission;
